import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "space-y-6"
}
const _hoisted_2 = ["for"]
const _hoisted_3 = {
  key: 0,
  class: "text-muted-foreground text-xs font-normal"
}
const _hoisted_4 = ["id", "aria-invalid"]
const _hoisted_5 = ["aria-pressed", "onClick"]
const _hoisted_6 = ["id", "value", "onChange", "aria-invalid"]
const _hoisted_7 = { value: "" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 2,
  class: "text-sm text-red-600 mt-1"
}

import type { CompanyIndustryAttributes, CompanyIndustryProfile } from '@/types/company'


export default /*@__PURE__*/_defineComponent({
  __name: 'IndustryAttributeFields',
  props: {
    profile: {},
    modelValue: {},
    errors: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const selectedValues = (key: string): string[] => {
  const value = props.modelValue?.[key]
  if (Array.isArray(value)) return value
  return typeof value === 'string' && value !== '' ? [value] : []
}

const emitWith = (key: string, value: string | string[] | null) => {
  const next: CompanyIndustryAttributes = { ...(props.modelValue ?? {}) }
  if (value === null || (Array.isArray(value) && value.length === 0)) {
    delete next[key]
  } else {
    next[key] = value
  }
  emits('update:modelValue', next)
}

const toggle = (key: string, value: string) => {
  const current = selectedValues(key)
  emitWith(
    key,
    current.includes(value) ? current.filter((item) => item !== value) : [...current, value]
  )
}

const setSingle = (key: string, value: string) => emitWith(key, value || null)

return (_ctx: any,_cache: any) => {
  return (_ctx.profile && _ctx.profile.fields.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.fields, (field) => {
          return (_openBlock(), _createElementBlock("div", {
            key: field.key
          }, [
            _createElementVNode("label", {
              for: `industry-attr-${field.key}`,
              class: "font-medium text-sm mb-2 block"
            }, [
              _createTextVNode(_toDisplayString(field.label) + " ", 1),
              (field.type === 'multiselect')
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, " (select all that apply) "))
                : _createCommentVNode("", true)
            ], 8, _hoisted_2),
            (field.type === 'multiselect')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  id: `industry-attr-${field.key}`,
                  class: "flex flex-wrap gap-2",
                  role: "group",
                  "aria-invalid": !!_ctx.errors?.[field.key]
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: option.value,
                      type: "button",
                      "aria-pressed": selectedValues(field.key).includes(option.value),
                      onClick: ($event: any) => (toggle(field.key, option.value)),
                      class: _normalizeClass(["px-3 py-1 rounded-full border text-sm transition-colors", selectedValues(field.key).includes(option.value)
            ? 'bg-brand text-white border-brand'
            : 'border-muted-foreground/30 text-muted-foreground hover:border-brand hover:text-foreground'])
                    }, _toDisplayString(option.label), 11, _hoisted_5))
                  }), 128))
                ], 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("select", {
                  key: 1,
                  id: `industry-attr-${field.key}`,
                  value: selectedValues(field.key)[0] ?? '',
                  onChange: ($event: any) => (setSingle(field.key, ($event.target as HTMLSelectElement).value)),
                  class: "w-full border border-border rounded-md px-3 py-2 focus:ring-2 focus:ring-brand focus:border-transparent outline-none",
                  "aria-invalid": !!_ctx.errors?.[field.key]
                }, [
                  _createElementVNode("option", _hoisted_7, "Select " + _toDisplayString(field.label.toLowerCase()), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: option.value,
                      value: option.value
                    }, _toDisplayString(option.label), 9, _hoisted_8))
                  }), 128))
                ], 40, _hoisted_6)),
            (_ctx.errors?.[field.key])
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.errors[field.key]), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})